import { useContext } from "react";
import { I18nContext } from "./I18nProvider";
import type { Locale } from "./locale";

export function useLocale(): {
  locale: Locale;
  setLocale: (next: Locale) => Promise<void>;
} {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useLocale must be used within I18nProvider");
  return { locale: ctx.locale, setLocale: ctx.setLocale };
}
